import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import { CHANGE_EVENT } from '../constants/AppConstants';
import { NAVIGATION_URL } from '../constants/DigitalStatementConstants';
let navigationTaskUrl;

class DigitalStatementsStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }

  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }

  getNavigationUrlName() {
    return navigationTaskUrl;
  }

  dispatcherCallback({ action: { actionType, data } }) {
    if (actionType === NAVIGATION_URL) {
      navigationTaskUrl = data;
      this.emitChange();
    }
  }
}

export default new DigitalStatementsStore();
